import { render } from "./ObjectiveModal.vue?vue&type=template&id=76fb1153"
import script from "./ObjectiveModal.vue?vue&type=script&lang=js"
export * from "./ObjectiveModal.vue?vue&type=script&lang=js"

import "./ObjectiveModal.vue?vue&type=style&index=0&id=76fb1153&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__